module.exports = __webpack_public_path__ + "img/sForestSec_193x205.f3cc89ab.png";